import React, { Fragment, useCallback } from "react";
import { usePalletShippingContext, usePalletShippingContextDispatcher } from "../pallet-shipping-context";
import { PalletShippingInformationSelectItem } from "./pallet-shipping-information-select-item";
import { FormControl, FormLabel, TextField } from "@mui/material";
import { t } from "i18next";
import { PalletShippingInformationSelect, ShippingInformationType } from "./pallet-shipping-information-select";
import { useWarehouseContext } from "../../warehouse-context/warehouse-context-provider";
import { GetPickupSlotHandler } from "../../../../../common/cqrs/query/get-pickup-slots/get-pickup-slots-handler";
import { GetPickupSlotsQuery } from "../../../../../common/cqrs/query/get-pickup-slots/get-pickup-slots-query";
import { PalletsListItem } from "../../pallets-list/pallets-list-item";

interface IPalletShippingInformationPickupSlotInputProps {
    palletsList: PalletsListItem[];
    onNoPickupAvailable: () => void;
}

export const PalletShippingInformationPickupSlotInput = (props: IPalletShippingInformationPickupSlotInputProps) => {
    const palletShippingContextDispatcher = usePalletShippingContextDispatcher();
    const { code: warehouseCode } = useWarehouseContext();
    const {
        shippingInformation: { containerSealNumber },
    } = usePalletShippingContext();

    const loadPickupSlots = useCallback(async () => {
        if (!warehouseCode) {
            return [];
        }

        const slots = (await GetPickupSlotHandler(new GetPickupSlotsQuery(warehouseCode, props.palletsList)))
            .map(ps => new PalletShippingInformationSelectItem(ps.id, ps.carrierName, ps.estimatedDepartureDate,
                ps.truckLicensePlate, "", ps.format()));

        if (slots.length === 0) {
            props.onNoPickupAvailable();

            return [];
        }

        return slots;
    }, [warehouseCode]);

    return <Fragment>
        <div className={"pallet-shipping-form__container pallet-shipping-form__container--full-width"}>
            <FormControl variant={"outlined"}
                         fullWidth>
                <FormLabel htmlFor={"ship-truck-id"}>
                    {t("components.pallet.shipping.containerSealNumber")}
                </FormLabel>
                <TextField id={"ship-truck-id"}
                           variant={"outlined"}
                           data-testid={"ship-truck-id"}
                           onChange={event => palletShippingContextDispatcher({
                               action: "setSealNumber",
                               sealNumber: event.target.value,
                           })}
                           value={containerSealNumber}/>
            </FormControl>
        </div>
        <PalletShippingInformationSelect shippingInformationType={ShippingInformationType.PickupSlot}
                                         loadData={loadPickupSlots} />
    </Fragment>;
};
